import { render } from "./WorkflowSettingsGeneral.vue?vue&type=template&id=438b12ed&scoped=true"
import script from "./WorkflowSettingsGeneral.vue?vue&type=script&lang=js"
export * from "./WorkflowSettingsGeneral.vue?vue&type=script&lang=js"

import "./WorkflowSettingsGeneral.vue?vue&type=style&index=0&id=438b12ed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438b12ed"]])

export default __exports__